function login(user) {
  return {
    type: 'LOGIN',
    payload: user
  };
}

function logout() {
  return {
    type: 'LOGOUT'
  };
}

function setIsLoading(isLoading) {
  return {
    type: 'LOADING',
    payload: isLoading
  };
}

function setPendingCount(count) {
  return {
    type: 'SET_PENDING_COUNT',
    payload: count
  };
}

export { login, logout, setIsLoading, setPendingCount };